import { atom } from 'recoil';
import type { InsuranceCompanyDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/insurancecompany/dto/';
import { insuranceCompaniesSelector } from '../selectors/insuranceCompaniesSelector';

export const insuranceCompaniesAtom = atom<InsuranceCompanyDTO[]>({
    key: 'insuranceCompaniesAtom',
    default: insuranceCompaniesSelector
});
